
import * as defaultImport from "uplot-react";
export * from "uplot-react";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
